import React, { Component } from 'react';
import { Label, Row, Col, Input, Table, Button, Tooltip } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'

class CommitmentsLedger extends Component {
    constructor(props) {
        super(props);

        const url = this.props.selector != null ? this.props.selector.split('/') : [];
        this.state = {
            investor: (url[0] != null && url[0] !== '') ? decodeURIComponent(url[0]).replace(/\//g, '-') : '',
            fund: (url[1] != null && url[1] !== '') ? decodeURIComponent(url[1]).replace(/\//g, '-') : '',
            date: (url[2] != null && url[2] !== '') ? url[2] : '',
            data: [],
            sheetData: [],
            filter: {},
            investors: [],
            funds: [],
            hideZeroCommitments: true,
            sort: 'fund',
            sortType: 'text',
            sortAsc: true,
            dbField: false,
            tooltipOpen: {},
            headers: [
                { display: 'Fund', accessors: ['fund'], type: 'text', filter: true, width: 48 },
                { display: 'Commitment Amount', accessors: ['commitment'], type: 'currency', classNames: 'text-right', width: 20 },
                { display: 'Amount Invested to Date', accessors: ['amount'], type: 'currency', classNames: 'text-right', width: 20 },
                { display: 'Unfunded Amount', accessors: ['unfundedAmount'], type: 'currency', classNames: 'text-right', width: 20 },
            ]
        };
    }

    componentDidMount() {
        this.props.log('CommitmentsLedger.js/componentDidMount');
        this.getInvestors(); this.getFunds(); this.onSubmit();
        this.props.passHeaders(this.state.headers, this.callback);
    }

    callback = (headers) => {
        this.props.log('CommitmentsLedger.js/callback (headers)', headers);
        this.setState({
            headers: headers
        }, () => this.getCSVdata());
    }

    getFormattedDate = (date) => {
        this.props.info('CommitmentsLedger.js/getFormattedDate (date)', date);
        let year = date.getFullYear();
        let month = (1 + date.getMonth());
        let day = date.getDate();
        return month + '/' + day + '/' + year;
    }

    getFormattedField = (val, type, hide) => {
        this.props.info('CommitmentsLedger.js/getFormattedField (val,type, hide)', val, type, hide);
        if (val == null || val === '') return val;
        switch (type) {
            case "date":
                return this.getFormattedDate(new Date(val.substr(0, 4), parseInt(val.substr(5, 2)) - 1, val.substr(8, 2)));
            case "number":
                return Intl.NumberFormat().format(parseFloat(val));
            case "currency":
                if (hide == null) {
                    return new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD',
                    }).format(val);
                } else if (hide) {
                    return val
                }
                break;
            default:
                val = String(val).replaceAll('_', '');
                return val;
        }
    }

    getInvestors = () => {
        this.props.log('CommitmentsLedger.js/getInvestors');
        fetch('/api/reports/InvestorListings', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            },
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        investors: results.data.map(item => { return (item.data != null && item.data.companyName != null) ? item.data.companyName : null })
                    });
                } else {
                    this.props.addToast('Unable to get investors.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getFunds = () => {
        this.props.log('CommitmentsLedger.js/getFunds');
        fetch('/api/reports/FundListings', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            },
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        funds: results.data.map(item => { return (item.data != null && item.data.fundName != null) ? item.data.fundName : null })
                    });
                } else {
                    this.props.addToast('Unable to get funds.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onSubmit = () => {
        this.props.log('CommitmentsLedger.js/onSubmit');
        fetch('/api/reports/CommitmentsLedger', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            },
            body: JSON.stringify([
                { key: 'investor', type: 'nvarchar', value: this.state.investor },
                { key: 'fund', type: 'nvarchar', value: this.state.fund },
                { key: 'date', type: 'date', value: this.state.date },
            ])
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        data: this.prepareData(results.data)
                    }, () => this.getCSVdata());
                } else {
                    this.props.addToast('Unable to download report.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    prepareData = (data) => {
        this.props.log('CommitmentsLedger.js/prepareData');
        data = data.map(item => {
            let obj = {};
            obj.data = item;
            return obj;
        });
        data.forEach(row => {
            row.data.commitment = 0;
            row.data.amount = 0;
            if (row.data.transactionData != null) {
                row.data.transactionData.forEach(transaction => {
                    switch (transaction.type) {
                        case "Buy":
                        case "Capital Call":
                        case "Return of Callable Capital":
                            row.data.amount += parseFloat(transaction.amount)
                            break;
                        case "Sell":
                            // case "Transfer Out":
                            // case "Dividend":
                            // case "Late Interest":
                            row.data.amount -= parseFloat(transaction.amount);
                            break;
                        // case "Pre-Funding":
                        //     row.data.prefunded += parseFloat(transaction.amount)
                        //     break;
                        case "Commitment":
                            row.data.commitment += parseFloat(transaction.amount);
                            break;
                        default:
                            break;
                    }
                })
            }
            row.data.unfundedAmount = row.data.commitment - row.data.amount;
        })
        let retArr = [];
        let obj = {};
        data.forEach((row) => {
            const investor = (row.data.investor != null ? row.data.investor : 'No Investor')
            if (obj[investor] == null) obj[investor] = [];
            obj[investor].push(row.data)
        })
        data = data.map(row => { return ({ data: { ...row, ...row.data }, formEntryId: 0 }) })
        Object.keys(obj).forEach(key => {
            retArr.push({ data: { fund: '__' + key } })
            obj[key].forEach(row => {
                retArr.push({ data: row })
            })
            retArr.push({
                data: {
                    fund: '_' + key + ' Total',
                    commitment: obj[key].reduce((prev, next) => (prev + parseFloat(next.commitment)), 0),
                    amount: obj[key].reduce((prev, next) => (prev + parseFloat(next.amount)), 0),
                    unfundedAmount: obj[key].reduce((prev, next) => (prev + parseFloat(next.unfundedAmount)), 0),
                },
            })
        })
        return retArr;
    }

    getCSVdata = () => {
        this.props.log('CommitmentsLedger.js/getCSVdata');
        if (this.state.data.length === 0) {
            this.props.passData([], '');
        } else {
            const retArr = [
                ['Investor', 'Date'],
                [
                    this.state.investor,
                    this.state.date !== '' ? this.getFormattedDate(new Date(this.state.date)) : '',
                ],
                []
            ].concat([
                this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                    header.display
                ))
            ]).concat(
                this.state.data.filter(row => row.data.commitment == null || (this.state.hideZeroCommitments && row.data.commitment > 0) || !this.state.hideZeroCommitments).map(row => {
                    let retArray = [];
                    this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).forEach((header, headerIndex) => {
                        // retArray[headerIndex] = this.getFormattedField(row.data[header.accessors[0]], header.type);
                        retArray[headerIndex] = headerIndex <= 1 ? (this.getFormattedField(row.data[header.accessors[0]], header.type, true)) :
                            !isNaN(parseFloat(this.getFormattedField(row.data[header.accessors[0]], header.type, true))) ? parseFloat(this.getFormattedField(row.data[header.accessors[0]], header.type, true)) : ''
                            ;
                    });
                    return retArray;
                })
            );
            const styleArr = [
                [
                    { s: { font: { bold: true }, fill: { fgColor: { rgb: 'ffffaa' } } } },
                    { s: { font: { bold: true }, fill: { fgColor: { rgb: 'ffffaa' } } } },
                    { s: { font: { bold: true }, fill: { fgColor: { rgb: 'ffffaa' } } } },
                ],
                [
                    { s: { fill: { fgColor: { rgb: 'ffffaa' } } } },
                    { s: { fill: { fgColor: { rgb: 'ffffaa' } } } },
                    { s: { fill: { fgColor: { rgb: 'ffffaa' } } } },
                ],
                []
            ].concat([
                this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                    { s: { font: { bold: true } } }
                ))
            ]).concat(
                this.state.data.filter(row => row.data.commitment == null || (this.state.hideZeroCommitments && row.data.commitment > 0) || !this.state.hideZeroCommitments).map(row => {
                    let styleArray = [];
                    this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).forEach((header, headerIndex) => {
                        switch (headerIndex) {
                            case 1:
                            case 2:
                            case 3:
                                // any currency columns
                                if (row.data.fund.substring(0, 2) === '__') {
                                    styleArray[headerIndex] = {
                                        // total row
                                        z: '$###,##0.00', s: { font: { bold: true, color: { rgb: parseFloat(row.data[header.accessors[0]]) < 0 ? 'ffffff' : 'ffffff' } }, fill: { fgColor: { rgb: '343a40' } } }
                                    }
                                } else if (row.data.fund.substring(0, 1) === '_') {
                                    styleArray[headerIndex] = {
                                        // header row
                                        z: '$###,##0.00', s: { font: { bold: true, color: { rgb: parseFloat(row.data[header.accessors[0]]) < 0 ? 'ffffff' : 'ffffff' } }, fill: { fgColor: { rgb: '6c757d' } } }
                                    }
                                } else {
                                    styleArray[headerIndex] = {
                                        // data row
                                        z: '$###,##0.00', s: { font: { color: { rgb: parseFloat(row.data[header.accessors[0]]) < 0 && !isNaN(parseFloat(row.data[header.accessors[0]])) ? '000000' : '000000' } } }
                                    };
                                }
                                break;
                            default:
                                // fund and sector columns
                                if (row.data.fund.substring(0, 2) === '__') {
                                    styleArray[headerIndex] = {
                                        // total row
                                        s: { font: { bold: true, color: { rgb: 'ffffff' } }, fill: { fgColor: { rgb: '343a40' } } }
                                    }
                                } else if (row.data.fund.substring(0, 1) === '_') {
                                    styleArray[headerIndex] = {
                                        // header row
                                        s: { font: { bold: true, color: { rgb: 'ffffff' } }, fill: { fgColor: { rgb: '6c757d' } } }
                                    }
                                } else {
                                    styleArray[headerIndex] = null
                                }
                        }
                    })
                    return styleArray;
                })
            );
            this.props.passData(retArr, "commitments-ledger", styleArr);
        }
    }

    onChange = (e) => {
        this.props.log('CommitmentsLedger.js/onChange (name, value, e)', e.target.name, e.target.value, e);
        e.persist();
        let value = '';
        let refresh = true;
        this.setState((prevState) => {
            let sel = prevState;
            sel[e.target.name] = (e.target.value);
            value = ((sel.investor) === '' ? '' : encodeURIComponent(sel.investor)) + '/' + ((sel.fund) === '' ? '' : encodeURIComponent(sel.fund)) + '/' + ((sel.date) === '' ? '' : sel.date);
            if (e.target.name === 'investor' && e.target.value === '0') {
                sel.investor = '';
                value = ((sel.fund !== '') ? '/' + sel.fund : '/');
                value += ((sel.date !== '') ? '/' + sel.date : '/');
            }
            if (e.target.name === 'fund' && e.target.value === '0') {
                sel.fund = '';
                value = ((sel.investor !== '') ? sel.investor + '/' : '/');
                value += ((sel.date !== '') ? '/' + sel.date : '/');
            }
            this.props.changeSelector({ target: { name: '', value: value.replace(/[/]+$/, '') } });
            return sel;
        }, () => {
            if (refresh) {
                this.onSubmit();
            }
            this.getCSVdata();
        });
    }

    onChangeFilter = (e) => {
        this.props.log('CommitmentsLedger.js/onChangeFilter (e)', e.target.name, e.target.value);
        e.persist();
        this.setState((prevState) => {
            let sel = prevState;
            sel.filter[e.target.name] = e.target.value;
            return sel;
        })
    }

    render() {
        this.props.info('CommitmentsLedger.js/render');
        return (
            <>
                <Row className="mb-4 noPrint">
                    <Col md={3} className="px-2">
                        <Label className='w-100'>Investor
                            <Input type="select" className="companySelect w-100" name="investor" value={this.props.replaceSpecialChars(this.props.isFieldNull(this.state.investor).replace(/\//g, '-'))} onChange={this.onChange}>
                                <option value="0">Show All</option>
                                {this.state.investors.map(investor => (
                                    <option key={investor} value={this.props.replaceSpecialChars(this.props.isFieldNull(investor).replace(/\//g, '-'))}>{investor}</option>
                                ))}
                            </Input>
                        </Label>
                    </Col>
                    <Col md={3} className="px-2">
                        <Label className='w-100'>Fund
                            <Input type="select" className="companySelect w-100" name="fund" value={this.props.replaceSpecialChars(this.props.isFieldNull(this.state.fund).replace(/\//g, '-'))} onChange={this.onChange}>
                                <option value="0">Show All</option>
                                {this.state.funds.map(fund => (
                                    <option key={fund} value={this.props.replaceSpecialChars(this.props.isFieldNull(fund).replace(/\//g, '-'))}>{fund}</option>
                                ))}
                            </Input>
                        </Label>
                    </Col>
                    <Col md={3} className="px-2">
                        <Label className='w-100' >Date
                            <Input type="date" name="date" value={this.props.isFieldNull(this.state.date)} onChange={this.onChange} />
                        </Label>
                    </Col>
                    <Col md={3} className="px-2">
                        <Label className='w-100' >
                            <Input type="checkbox" name="hideZeroCommitments" checked={this.state.hideZeroCommitments} onChange={() => this.setState({ hideZeroCommitments: !this.state.hideZeroCommitments })} />
                            Hide Zero Commitments
                        </Label>
                    </Col>
                </Row>
                {this.state.data.length > 0 ?
                    <Table>
                        <thead>
                            <tr>
                                {this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                                    <th className={'pointer ' + header.classNames}
                                        onClick={() => this.setState(this.props.setSort(header.accessors[0], header.type, this.state.sort, this.state.sortAsc, header.dbField))}
                                        key={headerIndex}>
                                        {header.display}
                                    </th>
                                ))}
                            </tr>
                            <tr>
                                {this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                                    <th key={headerIndex}>
                                        {header.filter ? <Input
                                            type="text"
                                            name={header.accessors[0]}
                                            placeholder={"Filter " + header.display}
                                            onClick={(e) => e.stopPropagation()}
                                            onChange={this.onChangeFilter}
                                            value={header.accessors[0] != null && this.state.filter[header.accessors[0]] != null ? this.state.filter[header.accessors[0]] : ''}
                                        /> : null}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.data.filter(row => row.data.commitment == null || (this.state.hideZeroCommitments && row.data.commitment > 0) || !this.state.hideZeroCommitments)
                                .filter(entry => {
                                    let temp = true;
                                    Object.keys(this.state.filter).forEach(field => {
                                        if ((entry.data[field] != null && this.state.filter[field] != null &&
                                            (entry.data[field].toUpperCase().indexOf(this.state.filter[field].toUpperCase()) === -1)) ||
                                            ((this.state.filter[field] != null && this.state.filter[field] !== '') && entry.data[field] == null)) temp = false;
                                    })
                                    return temp;
                                }).map((row, rowIndex) => (
                                    <tr key={row.formEntryId + '-' + rowIndex} className={row.data.fund.indexOf('_') > -1 ? "font-weight-bold" : ""}>
                                        {this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                                            <td className={(header.dbField ? "dbField" : "") + " " + (header.classNames) + " " + (row.data.fund.indexOf('__') > -1 ? " pt-4 text-white bg-dark" : ((row.data.fund.indexOf('_') > -1 ? " pt-4 text-white bg-secondary" : "")))}
                                                key={headerIndex}>
                                                {header.dbField ?
                                                    this.getFormattedField(row[header.accessors[0]], header.type)
                                                    : this.getFormattedField(row.data[header.accessors[0]], header.type)}
                                                {header.accessors[0] === 'fund' && row.data.transactionData != null ?
                                                    // <>&nbsp;<Button color="link"
                                                    //     title={row.data.transactionData.map(transaction => {
                                                    //         let str = transaction.type + ': ' + this.getFormattedField(transaction.amount, 'currency') + ' (' + this.getFormattedDate(new Date(transaction.tradeDate)) + ')';
                                                    //         return (str)
                                                    //     }).join("\n")}
                                                    // ><FontAwesomeIcon icon={faQuestionCircle} /></Button></>
                                                    <><Button color="link" className="p-0 m-0"
                                                        id={'button-' + rowIndex}
                                                    ><FontAwesomeIcon icon={faQuestionCircle} /></Button>
                                                        <Tooltip
                                                            innerClassName="tooltipInner"
                                                            placement="right"
                                                            target={'button-' + rowIndex}
                                                            trigger="click hover focus"
                                                            isOpen={this.state.tooltipOpen['button-' + rowIndex] != null ? this.state.tooltipOpen['button-' + rowIndex] : false}
                                                            toggle={() => this.setState((prevState) => {
                                                                let obj = { ...prevState };
                                                                obj.tooltipOpen['button-' + rowIndex] = (obj.tooltipOpen['button-' + rowIndex] != null ? !obj.tooltipOpen['button-' + rowIndex] : true);
                                                                return obj
                                                            })}
                                                        >
                                                            <table>
                                                                <tbody>
                                                                    {row.data.transactionData && row.data.transactionData.map((transaction, transactionIndex) => (
                                                                        <tr key={transactionIndex} className="text-left text-nowrap">
                                                                            <td className='text-right'>{transaction.type}:</td>
                                                                            <td className='text-right'>{this.getFormattedField(transaction.amount, 'currency')}</td>
                                                                            <td>({this.getFormattedDate(new Date(transaction.tradeDate + 'T00:00:00'))})</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </Tooltip>
                                                    </>


                                                    : ''}

                                            </td>
                                        ))}
                                    </tr>
                                ))}
                        </tbody>
                    </Table>
                    : <>No results</>}
            </>
        );

    }
}

export default CommitmentsLedger;
